import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { HttpService } from './api/http.service';
import { Observable, Subject, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PermissionsService {

  constructor(private _auth:AuthService, private _api: HttpService) { }

  userPermission: any[] | null = null;
  private readonly permissionsChangedSubject = new Subject<void>();
  readonly permissionsChanged$ = this.permissionsChangedSubject.asObservable();

  setUserPermissions(permissions:any) {
    localStorage.setItem('permissions',JSON.stringify(permissions));
    this.userPermission = permissions;
    this.permissionsChangedSubject.next();
  }

  getUserPermissions(): any | null {
    const perm = JSON.parse(localStorage.getItem('permissions')!) || [];
    return perm;
  }

  refreshUserPermissions(): Observable<any> {
    return this._api.getReq('/myPermissions').pipe(
      tap((response: any) => this.setUserPermissions(this.extractPermissions(response)))
    );
  }

  hasPermission(desiredPermission: string): boolean {
    if(this._auth.getUserType() == 'Central'){
      return true
    }
    return this.getPermissionNames().includes(desiredPermission);
  }
  hasListPermissions(desiredPermission: any[]): boolean {
    if(desiredPermission == null || desiredPermission.length == 0){
      return true;
    }
    if(this._auth.getUserType() == 'Central'){
      return true
    }
    return this.getPermissionNames().some((permission) => desiredPermission.includes(permission));
  }

  private extractPermissions(response: any): any[] {
    const data = response?.data;
    const permissions = Array.isArray(data)
      ? data
      : data?.permissions ?? data?.data ?? response?.permissions ?? [];

    return Array.isArray(permissions) ? permissions : [];
  }

  private getPermissionNames(): string[] {
    const permissions = this.getUserPermissions();
    if (!Array.isArray(permissions)) return [];

    return permissions
      .map((permission: any) => typeof permission === 'string'
        ? permission
        : permission?.name ?? permission?.code ?? permission?.slug ?? permission?.permission)
      .filter((permission: unknown): permission is string => typeof permission === 'string');
  }

}
